export const getServerHost = (uri: string): string => {
  let url = uri.startsWith('/') ? uri.replace('/', '') : uri

  return process.env.REACT_APP_API_SERVER_HOST + url || ''
}